/**
 * Laboratory API Endpoints
 * Centralized endpoint definitions for laboratory identity operations.
 */
export const LABORATORY_ENDPOINTS = {
  /**
   * Get laboratory logo (default format)
   * @method GET
   * @endpoint /laboratory/logo
   */
  LOGO: "/laboratory/logo",

  /**
   * Get laboratory logo in specific format
   * @method GET
   * @endpoint /laboratory/logo/{format}
   * @param {string} format - Logo format (png or svg)
   */
  LOGO_FORMAT: (format: string) => `/laboratory/logo/${format}`,

  /**
   * Get laboratory name
   * @method GET
   * @endpoint /laboratory/name
   * @query {string} culture - Optional language code
   */
  NAME: "/laboratory/name",

  /**
   * Get laboratory terms of use
   * @method GET
   * @endpoint /laboratory/terms-of-use
   * @query {string} culture - Optional language code
   */
  TERMS_OF_USE: "/laboratory/terms-of-use",
} as const;
